module.exports = __webpack_public_path__ + "static/img/img2-6.23da377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/126/img2-6.jpg
// module id = hWn7
// module chunks = 0